// Fiora — Riposte: Parries all incoming attacks for 2 turns (90% damage reduction),
// then lunges at the front enemy for 2× AD physical damage.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const fioraRiposte: Ability = {
  id: "fioraRiposte",
  displayName: "Riposte",
  description: "Parries incoming damage (90% reduction) for 2 turns, then strikes the front enemy for 2× AD.",
  iconId: "FioraW",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const front = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    return [caster.pos, ...(front ? [front.pos] : [])];
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const target = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q)[0];
    const stats = effectiveStats(caster);

    const hits: AbilityHit[] = [
      { target: caster, amount: 0, type: "none", effect: { kind: "damageReduction", percent: 0.45, duration: 2 } },
    ];
    if (target) {
      hits.push({ target, amount: physicalDamage(stats.ad * 2.0 + 60), type: "physical" });
    }
    return hits;
  },
};
